import { withStyles } from '@material-ui/core';
import CardFooter from './CardFooter';
import styles from './styles';

export default withStyles(styles)(CardFooter);
